import { render, staticRenderFns } from "./view-map-shop.vue?vue&type=template&id=7dfe5fe8&"
import script from "./view-map-shop.vue?vue&type=script&lang=js&"
export * from "./view-map-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports